module.exports = __webpack_public_path__ + "img/NATURALES.2c41b23f.png";